import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { FaEnvelope } from 'react-icons/fa';
import api from '../../../utils/api';
import { AuthShell } from './AuthShell';
import { YButton } from '../../../ui/YButton';
import { YFormField } from '../../../ui/YFormField';
import { AuthInputWithIcon } from './AuthInputWithIcon';
import '../styles/auth-design.css';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const GENERIC_SENT_MESSAGE =
  'If an account exists for that email, we sent a reset link.';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const trimmed = email.trim();
    if (!EMAIL_RE.test(trimmed)) {
      setError('Enter a valid email address');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/password-reset/', { email: trimmed });
      setSent(true);
    } catch (err) {
      const message = err.response?.data?.error;
      if (err.response?.status === 400 && message) {
        setError(message);
      } else {
        // Network / 5xx: still do not reveal whether the address is registered.
        setSent(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell className="auth-forgot-shell">
      <div className="auth-panel">
        <div className="auth-panel__heading">
          <h1 className="auth-panel__title">Reset your password</h1>
          <p className="auth-panel__subtitle">
            Enter your email and we&apos;ll send a link if an account exists for it.
          </p>
        </div>

        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        {sent && (
          <Alert variant="success" className="mb-3">
            {GENERIC_SENT_MESSAGE} Check your inbox.
          </Alert>
        )}

        <form className="auth-form-stack" onSubmit={handleSubmit} noValidate>
          <YFormField label="Email address" htmlFor="forgot-email">
            <AuthInputWithIcon
              id="forgot-email"
              type="email"
              icon={FaEnvelope}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@email.com"
              disabled={loading || sent}
            />
          </YFormField>

          <YButton type="submit" variant="primary" block disabled={loading || sent}>
            {loading ? 'Sending…' : 'Send reset link'}
          </YButton>
        </form>

        <p className="auth-switch-line">
          <Link to="/" className="auth-forgot-link">
            Back to sign in
          </Link>
        </p>
      </div>
    </AuthShell>
  );
}
